import React, { useEffect, useRef } from 'react';
import { Box, IconButton, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, useBreakpointValue, } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import CloseIcon from '../../icons/CloseIcon/CloseIcon';
import { PhotoSize } from '../../../types/enums/PhotoSize';
import useStyling from '../../../hooks/useStyling';
import { ArrowIconDirection } from '../../icons/ArrowIcon';
import useNavigation from '../../../hooks/usePrevNextNavigation';
import NavigationButton from './NavigationButton';
import PhotoWrapper from '../Photos/PhotoWrapper';
const MediaViewerModal = ({ isOpen, onClose, loadedPhotos, selectedItem, allMedia, isShare = false, }) => {
    const tokens = useTokens();
    const { prevItem, nextItem, currentItem, setCurrentItem } = useNavigation(allMedia, selectedItem);
    const { mediaViewer: styles } = useStyling();
    const breakpointWidth = useBreakpointValue({
        base: allMedia ? '1280px' : '1100px',
        lg: allMedia ? '1280px' : '1100px',
        sm: '100%',
    }, {
        fallback: 'lg',
    });
    const galleryRefs = useRef([]);
    useEffect(() => {
        const currentIndex = allMedia.findIndex((item) => item.id === currentItem.id);
        const ref = galleryRefs.current?.[currentIndex];
        if (!ref)
            return;
        ref.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });
    }, [currentItem, allMedia]);
    const onThumbnailKeyDown = (e, item) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            setCurrentItem(item);
        }
    };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "full", scrollBehavior: "inside", isCentered: true, motionPreset: "none" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { pt: "52px", bgColor: tokens.Layer03, role: "alertdialog", "aria-labelledby": "modal-header", "data-testid": "photo_viewer-modal__content" },
            React.createElement(ModalBody, { w: breakpointWidth, h: "596px", ml: "auto", mr: "auto", padding: 0 },
                React.createElement(IconButton, { sx: styles.closeButton, icon: React.createElement(CloseIcon, null), mr: "26px", w: "56px", variant: "white-grey", onClick: onClose, "aria-label": localise('CLOSE'), onKeyDown: (e) => e.stopPropagation(), "data-testid": "photo_viewer-modal__close_button" }),
                React.createElement(Box, { minWidth: "max-content", alignItems: "center", gap: "4", sx: styles },
                    React.createElement(NavigationButton, { iconDirection: ArrowIconDirection.LEFT, id: "previous", "aria-label": localise('PREVIOUS_IMAGE'), "data-testid": "photo_viewer-model__previous_button", right: "1068px", onClick: prevItem }),
                    React.createElement(NavigationButton, { iconDirection: ArrowIconDirection.RIGHT, id: "next", "aria-label": localise('NEXT_IMAGE'), "data-testid": "photo_viewer-model__next_button", right: tokens.Spacing01, onClick: nextItem }),
                    React.createElement(Box, { sx: styles.thumbnailWrapper }, allMedia.map((item, index) => {
                        const loadedPhoto = loadedPhotos?.find((p) => p.id === item.id);
                        return (React.createElement(Box, { key: item.id, ref: (el) => (galleryRefs.current[index] = el), sx: item.id === currentItem.id
                                ? styles.thumbnailWrapper.selectedImage
                                : styles.thumbnailWrapper.deselectedImage, w: "104px", h: "104px", mb: "23px", ml: "2px", onClick: () => {
                                setCurrentItem(item);
                            }, onKeyDown: (e) => onThumbnailKeyDown(e, item), tabIndex: 0 },
                            React.createElement(PhotoWrapper, { isShare: isShare, photo: item, loadedPhoto: loadedPhoto, size: PhotoSize.SMALL, shouldLoad: !loadedPhoto, fallbackStrategy: "onError" })));
                    })),
                    React.createElement(Box, { id: "image-wrapper", "data-testid": "photo_viewer-modal__image_wrapper", overflow: "auto" },
                        React.createElement(PhotoWrapper, { key: currentItem.id, isShare: isShare, photo: currentItem, size: PhotoSize.ORIGINAL, shouldLoad: true, spinnerProps: { size: 'xl' }, fallbackStrategy: "onError", fit: "contain" })))),
            React.createElement(ModalFooter, null))));
};
export default MediaViewerModal;
